var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "mb-5 px-md-5", attrs: { fluid: "" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "align-h": "center" } },
        [
          _c("page-header", {
            attrs: {
              title: _vm.$tc("global.doorr.referrerSlashParticipant", 2),
              subtitle: _vm.$t("referrers.subtitle"),
              "title-class": "page-header text-capitalize",
            },
          }),
          _vm._v(" "),
          _c("referrer-list-actions", {
            ref: "referrerActions",
            attrs: { "search-string": _vm.searchString },
            on: {
              search: _vm.searchReferrer,
              add: _vm.handleOpenAddReferrerModal,
              filter: _vm.handleFilter,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "no-gutters": "" } },
        [
          _vm.loading
            ? _c("b-col", [_c("b-card", [_c("table-loader")], 1)], 1)
            : _c("b-col", [
                _c(
                  "div",
                  { staticClass: "d-flex mb-2" },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "grey-text text-darken-1 text-primary bold mb-0 text-nowrap",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.tableSummaryText) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.currentFilters
                      ? _c(
                          "b-row",
                          { attrs: { "align-v": "start", "no-gutters": "" } },
                          _vm._l(_vm.currentFilters, function (tag) {
                            return _c(
                              "span",
                              {
                                key: tag.text,
                                staticClass:
                                  "ml-2 badge status-badge current-filter-badge",
                                style:
                                  "--progress-item-variation: " +
                                  tag.variation +
                                  "deg",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(tag.text) +
                                    "\n            "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-1 clickable",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearFilter(tag.filter)
                                      },
                                    },
                                  },
                                  [_c("icon", { attrs: { name: "times" } })],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "position-relative" },
                  [
                    _c("referrers-table", {
                      attrs: {
                        id: "referrers-table",
                        referrers: _vm.GET_CURRENT_REFERRERS,
                        loading: _vm.loadingTable,
                      },
                      on: { sort: _vm.handleSort },
                    }),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingReferrers
        ? _c(
            "b-row",
            { staticClass: "px-0", attrs: { "no-gutters": "" } },
            [_c("row-loader")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("manage-referrer-modal", {
        ref: "addReferrerModal",
        attrs: { submitting: _vm.creatingReferrer },
        on: { submit: _vm.handleCreateReferrer },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }